import OpenedEnvelop from '@/components/OpenedEnvelop';
import { IPostData } from '@/interfaces/api/post';
import React from 'react';
import s from './styles.module.scss';
import { linkifyText } from '@/utils/dom';
import DOMPurify from 'dompurify';
import { CDN_URL_ICONS } from '@/configs';
import IcTokenDonate from './icTokenDonate';

interface IProps {
  data: IPostData;
}

const DonateTokenPost: React.FC<IProps> = ({ data }): React.ReactElement => {
  const onClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className={s.lixiPost}>
      <div className={s.content}>
        <span
          onClick={onClick}
          dangerouslySetInnerHTML={{
            __html: linkifyText(DOMPurify.sanitize(data?.content)),
          }}
        />
      </div>
      <IcTokenDonate />
      {/* <img
        className={s.rainLixiIcon}
        src={`${CDN_URL_ICONS}/token_airdrops.svg`}
        alt="ic-airdrop"
      /> */}
    </div>
  );
};

export default React.memo(DonateTokenPost);
